import React, { useEffect } from 'react'
import { PersonViewerInitialState, PersonViewerReducer } from './PersonViewerReducer'

const PersonViewerStateContext = React.createContext()
const PersonViewerDispatchContext = React.createContext()

function PersonViewerProvider({ children }) {
  const [state, dispatch] = React.useReducer(PersonViewerReducer, PersonViewerInitialState)
  return (
    <PersonViewerStateContext.Provider value={state}>
      <PersonViewerDispatchContext.Provider value={dispatch}>{children}</PersonViewerDispatchContext.Provider>
    </PersonViewerStateContext.Provider>
  )
}

function usePersonViewerState() {
  const context = React.useContext(PersonViewerStateContext)
  if (context === undefined) {
    throw new Error('ERROR: usePersonViewerState must be used inside of PersonViewerProvider')
  }
  return context
}

function usePersonViewerDispatch() {
  const context = React.useContext(PersonViewerDispatchContext)
  if (context === undefined) {
    throw new Error('ERROR: usePersonViewerDispatch must be used inside of PersonViewerProvider')
  }
  return context
}

function usePersonViewerInitialization() {
  // use this hook only once to load required application data on page load
  const dispatch = usePersonViewerDispatch()
  const state = usePersonViewerState()

  useEffect(() => {
    if (!state.isLoading) {
      return
    }

    dispatch(
      {
        type: 'INIT_PersonViewer',
        data: {
          lockMemories: false,
        },
      },
      []
    )
  })
}

export { PersonViewerProvider, usePersonViewerState, usePersonViewerInitialization, usePersonViewerDispatch }
